import { render, staticRenderFns } from "./PanelInputRadio.vue?vue&type=template&id=3a55d2f5&scoped=true&"
import script from "./PanelInputRadio.vue?vue&type=script&lang=js&"
export * from "./PanelInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputRadio.vue?vue&type=style&index=0&id=3a55d2f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a55d2f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a55d2f5')) {
      api.createRecord('3a55d2f5', component.options)
    } else {
      api.reload('3a55d2f5', component.options)
    }
    module.hot.accept("./PanelInputRadio.vue?vue&type=template&id=3a55d2f5&scoped=true&", function () {
      api.rerender('3a55d2f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelInputRadio.vue"
export default component.exports